// removed by extract-text-webpack-plugin
module.exports = {"page-wrapper":"styles__page-wrapper___2bmpH","title":"styles__title___3WzNu","category-name":"styles__category-name___YaYJO","categories":"styles__categories___rQ_nA","wrap":"styles__wrap___2_z8L","description":"styles__description___2pLwK"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Rentals/styles.scss
// module id = 434
// module chunks = 0